import {AppConfig} from "./app-config";

export interface IConfigService<T extends AppConfig> {
  initializeConfig(config: T): void;
  setConfig(config: T): void;
  getConfig(): T
}

export class ConfigService<T extends AppConfig> implements IConfigService<T> {
  private config!: T;

  constructor() {
  }

  initializeConfig(config: T) {
    let existing = this.getConfig();
    config.customerName = existing?.customerName || this.getCustomer();
    this.setConfig(config);
  }

  setConfig(config: T) {
    this.config = config;
    this.storeCustomer();
  }

  getConfig(): T {
    return this.config;
  }

  private storeCustomer(): void {
    if (this.config) {
      localStorage.setItem('customer-name', this.config.customerName);
    }
  }

  private getCustomer(): string {
    return localStorage.getItem("customer-name") || "";
  }

}

